// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {

	// Header Mobile change
	if (window.innerWidth < 768) {
		document.querySelector('.header__logo img').src =`${site_url}assets/svg/Logo-Alternad.svg`;
	}
	

	let itemsMenu = document.querySelectorAll(
		'.privary-navigation .privary-navigation__item',
	)
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			itemMenu.addEventListener('mouseenter', () => {
				itemMenu.classList.add('hover')
				itemMenu.querySelector('.submenu').classList.add('show')
			})
			itemMenu.addEventListener('mouseleave', () => {
				itemMenu.classList.remove('hover')
				itemMenu.querySelector('.submenu').classList.remove('show')
			})
		}
	})

	// Burger Menu Funcionality Open and Close Menu
	const btn_Menu = document.querySelectorAll('[data-ctaburger]')
	const menu_Section = document.querySelector('[data-menuburger]')
	btn_Menu.forEach((cta) => {
		cta.addEventListener('click', (e) => {
			e.preventDefault()
			menu_Section.classList.toggle('open')
			document.body.classList.toggle('no-scroll')
		})
	})

	const menu_Close= document.querySelector('.burger-menu__bg')
	if (menu_Close) {
		menu_Close.addEventListener('click', () => {
			console.log("click");
			document.body.classList.remove('no-scroll');
			menu_Section.classList.remove('open');
		})
	}

	//Animation Parallax image
	const images = document.querySelectorAll(
		'#home figure img:not(.no-parallax), #default figure img:not(.no-parallax), .parallax',
	);

	function initializeParallax() {
		if (typeof ukiyoInstances !== 'undefined') {
				ukiyoInstances.forEach(instance => instance.destroy());
		}

		ukiyoInstances = Array.from(images).map(img => new Ukiyo(img, {
				scale: 1.1,
				speed: 1.7,
				willChange: true,
		}));
	}

	let ukiyoInstances = [];
	initializeParallax();
	window.addEventListener('resize', () => {
		initializeParallax();
	});

	//animation scroll
	const ctas_scroll = document.querySelectorAll('[data-scroll],.scroll')
	if (ctas_scroll) {
		ctas_scroll.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				const section_to_scroll = new URL(e.target.href)
				animateTo(section_to_scroll.hash)
			})
		})
	}

	//functionality tabs home
	const topContentSlider  = document.querySelector('#top-content .swiper-slider');
	if (topContentSlider) {
		const lighthouse_Left = document.querySelector('.header__menu');
		const lighthouse_Right = document.querySelector('.header__right a');
		lighthouse_Left.addEventListener('mouseenter', () => {
			topContentSlider.swiper.slideTo(1);
		})
		lighthouse_Left.addEventListener('mouseleave', () => {
			topContentSlider.swiper.slideTo(0);
		})
		lighthouse_Right.addEventListener('mouseenter', () => {
			topContentSlider.swiper.slideTo(2);
		})
		lighthouse_Right.addEventListener('mouseleave', () => {
			topContentSlider.swiper.slideTo(0);
		})
		

	}

	//Kite Observer 
	const gallerySection = document.querySelectorAll('.gallery-block , .decoration-bottom');
	if (gallerySection && window.innerWidth > 767) {
		const headerHeight = document.getElementById("header").clientHeight;
		window.addEventListener('scroll', () => {
			gallerySection.forEach((section) => {
				const sectionPosition = section.getBoundingClientRect().top;
				
				if (sectionPosition <= headerHeight) {
					section.classList.add('visible');
				} else {
					section.classList.remove('visible');
				}
			});
		});
	}

	// section goto
	const all_btn = document.querySelectorAll('.btn, .btn-white');
	all_btn.forEach((btn) => {
			const href = btn.getAttribute('href');
			if (href && href.includes('sectiongoto#')) {
					btn.addEventListener('click', (e) => {
							e.preventDefault(); 
							const targetElement = new URL(e.target.href).hash;
							console.log(targetElement);
							animateTo(targetElement);
					});
			}
	});

	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	//Press Cta functionality
	const pressCtas = document.querySelectorAll('[data-pressform]')
	if (pressCtas) {
		pressCtas.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				document.querySelector('.intro-press__form').classList.toggle('open')
			})
		})
	}

	//mobile inputs functionality
	if (window.innerWidth >= 768) {
    const inputs = document.querySelectorAll('input[type="date"], input[type="time"]');
    inputs.forEach(input => {
        input.addEventListener("input", function () {
            if (this.value.length > 0) {
                this.classList.add("full"); 
            } else {
                this.classList.remove("full"); 
            }
        });
    });
	}

	//LBX custom funcionality
	const all_Lbx = LBX._instances;

	all_Lbx.forEach((lbx) => {
		lbx.icons.close =`<svg xmlns="http://www.w3.org/2000/svg" width="12.863" height="9.68" viewBox="0 0 12.863 9.68">
		<path  data-name="Path 213510" d="M9.405-7.136,7.347-5.024l2.394,2.48,2.3,2.128.738.112-.022.3h-4.7L8.041-.336,9.025-.4l-1.1-1.712L6.094-4.032,4.349-2.256,3.209-.416l.984.08L4.17,0H-.058L-.08-.3.658-.416,3.007-2.544,5.244-4.912l-2.1-2.224L.86-9.264.211-9.376l.022-.3H4.909l.022.336-1.1.08L4.976-7.536,6.542-5.888,8.018-7.424l1.141-1.84-.895-.08.022-.336h4.161l.022.3-.671.112Z" transform="translate(0.08 9.68)" fill="#f1e9e0"/></svg>` ;
	});

	const countDown = function (elements) {

		for (const element of elements) {
	
			const date = element.dataset.date;
			let formats = element.dataset.formats;
	
			if (!date || !formats)
				return;
			
			formats = formats.split(',');
			const format = formats.map(format => `<div class="countdown-time"><span></span>${format}</div>`).join('');
			element.insertAdjacentHTML("beforeend", format);
		
			const countDownDate = new Date(date).getTime();
			
			const timer = () => {
				let now = new Date().getTime();
				let dateDiff = countDownDate - now;
		
				let time = {
					days: String(Math.floor(dateDiff / (1000 * 60 * 60 * 24))).padStart(2, '0'),
					hours: String(Math.floor((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0'),
					minutes: String(Math.floor((dateDiff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0'),
					seconds: String(Math.floor((dateDiff % (1000 * 60)) / 1000)).padStart(2, '0')
				}
	
				time = Object.values(time);
	
				for (let i = 0; i < formats.length; i++) {
					element.getElementsByTagName("div")[i].getElementsByTagName("span")[0].textContent = time[i];
				}
		
				if (dateDiff < 0)
					clearInterval(timerInterval);
			}
		
			timer();
		
			const timerInterval = setInterval(timer, 1000);
		}
	
	}
	document.getElementsByClassName("js-countdown") && countDown(document.getElementsByClassName("js-countdown"));

})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling

	if (window.innerWidth > 767 && !document.querySelector("#home") && document.querySelector("nav.sub-menu")) {
		const subnavScroll = document.querySelector(".sub-menu__hold");
		const elementparent = subnavScroll.previousElementSibling.offsetHeight;
		const nextelement = subnavScroll.nextElementSibling;
		const headerheight = document.getElementById("header").offsetHeight;
		console.log(elementparent);
		if (lastScrollTop > (elementparent - headerheight)) {
			subnavScroll.classList.add("fixed");
			nextelement.classList.add("intro--subnav");
		} else {
			subnavScroll.classList.remove("fixed");
			nextelement.classList.remove("intro--subnav");
		}
	}

}
//animation of scroll vanilla JS
function animateTo(target) {

	const targetElement = document.querySelector(target);
	if (!targetElement) {
			console.error(`Elemento no encontrado: ${target}`);
			return;
	}

	const gotoTarget = targetElement.getBoundingClientRect().top + window.pageYOffset - 110;

	const from = window.pageYOffset;
	const to = gotoTarget;
	const duration = 1300; 
	const start = performance.now(); 

		function easeInOutQuart(t, b, c, d) {
			t /= d / 2;
			if (t < 1) return c / 2 * t * t * t * t + b;
			t -= 2;
			return -c / 2 * (t * t * t * t - 2) + b;
	}

	
	function animateScroll() {
			const currentTime = performance.now() - start;
			const progress = Math.min(currentTime / duration, 1);
			const newY = easeInOutQuart(currentTime, from, to - from, duration);
			window.scrollTo(0, newY);
			if (currentTime < duration) {
					requestAnimationFrame(animateScroll);
			}
	}

	// Iniciar la animación
	animateScroll();
}
/* Subnav on mobile */

// Seleccionamos todos los elementos necesarios
const submenuHold = document.querySelectorAll('.sub-menu__hold');
const allSubLinks = document.querySelectorAll('.sub-menu a');

// Función para manejar el comportamiento de los enlaces
function handleSubmenuLinks(links) {
  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      if (link.classList.contains('active')) {
        event.preventDefault();
      }
    });
  });
}


function setupToggleBtn(toggleBtn) {
  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      toggleBtn.parentElement.classList.toggle('open'); 
    });

   
    const activeLink = document.querySelector('.sub-menu a.active');
    if (activeLink) {
      toggleBtn.textContent = activeLink.textContent;
    }
  }
}

if (allSubLinks.length > 1) {
  handleSubmenuLinks(allSubLinks); 
  const toggleBtn = document.querySelector('.sub-menu__toggle');
  setupToggleBtn(toggleBtn);
} else if (submenuHold.length > 0) {
  submenuHold[0].classList.add('hidden'); 
}

allSubLinks.forEach((link) => {
	const href = link.getAttribute('href');
			if (href && href.includes('#form') || href.includes('#section_')) {
				link.addEventListener('click', (e) => {
							const targetElement = new URL(e.target.href).hash;
							if(document.querySelector(targetElement)){
								e.preventDefault(); 
								animateTo(targetElement);
							}
					});
			}
});

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
	const menu = document.querySelector('.burger-menu');
	const isMenuVisible = menu && menu.classList.contains('open');
	const elements = document.querySelectorAll('#primary-nav a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}
document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('.burger-menu');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});
